import { Button, FormControl, InputLabel, makeStyles, MenuItem, Select, Typography } from "@material-ui/core";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import React, { useState, useReducer, useEffect } from "react";
import { AccentsAndDialectsDD } from "../../../globalConstants";
import translate from "../../../i18n/translate";
import "./AccentsAndDialects.scss";
import ReactAudioPlayer from "react-audio-player";
import RollbarErrorTracking from "../../../utils/RollbarErrorTracking";
import Axios from "axios";

const AccentsAndDialects: React.FC = () => {
  const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 250,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  }));

  const ADcontinentLists = AccentsAndDialectsDD[0].ContinentList;
  const ADcountryLists = AccentsAndDialectsDD[0].ContinentMap;
  const classes = useStyles();
  const [continents] = useState(ADcontinentLists);
  const [isstatedisabled, setStatedisabled] = useState(false);
  const [islocation, setlocation] = useState<any>();
  const [isbody, setbody] = useState<any>();
  const [isUSlocation, setUSlocation] = useState<any>();
  const [isUSbody, setUSbody] = useState<any>();
  const [isdisabled, setdisabled] = useState(true);
  const [isUSdisabled, setUSdisabled] = useState(false);

  let [topic, setTopic] = useState("");
  let [topicUS, setUSTopic] = useState("");
  let [countries, setCountries] = useState<any>([]);
  let [states, setStates] = useState<any>([]);

  function handleChange(event: any, isEvent: boolean, selectionValue: string) {
    const ADcountryLists = AccentsAndDialectsDD[0].ContinentMap;
    const inputValue: string = isEvent ? event.target.value : selectionValue;
    let countryList = ADcountryLists.filter((data) => data.Name === inputValue);
    sessionStorage.setItem("accentsContinentSelected", inputValue);
    setCountries(countryList[0].countries);
    setStates(countryList[0].states);
    handleChangeValue("", false, countryList[0].countries[0]);
    handleChangeValueStates("", false, countryList[0].states[0]);
  }

  async function fetchData(topicID: string) {
    const data = await Axios.get(`${process.env.REACT_APP_BLOB_STORAGE}/accentsanddialects/${topicID}.json`)
      .then((response) => {
        return response.data;
      })
      .catch((err: any) => {
        toasterHandle(true, "error", "message_errorDefault");
        RollbarErrorTracking.logErrorInRollbar(err.message, "error");
      });
    return data;
  }

  const handleChangeValue = async (event: any, isEvent: boolean, selectionValue: string) => {
    const inputValue: string = isEvent ? event.target.value : selectionValue;
    sessionStorage.setItem("accentscountrySelected", inputValue);
    const topicID: string = `${sessionStorage.getItem("accentsContinentSelected")}${inputValue}`;
    if (sessionStorage.getItem("accentscountrySelected") === "US") {
      const topicUSID: string = `${sessionStorage.getItem("accentscountrySelected")}${sessionStorage.getItem(
        "accentsstateSelected"
      )}`;
      const localeUSData: any = await fetchData(topicUSID);
      setStatedisabled(true);
      setUSdisabled(true);
      setdisabled(false);
      setUSlocation(localeUSData);
      handleChangeValueUStopic("", false, localeUSData.meta.titles[0].title, localeUSData);
    } else {
      const localeData: any = await fetchData(topicID);
      setStatedisabled(false);
      setUSdisabled(false);
      setdisabled(true);
      setlocation(localeData);
      handleChangeValuetopic("", false, localeData.meta.titles[0].title, localeData);
    }
  };

  const handleChangeValueStates = async (event: any, isEvent: boolean, selectionValue: string) => {
    const inputValue: string = isEvent ? event.target.value : selectionValue;
    sessionStorage.setItem("accentsstateSelected", inputValue);
    let topicID: string = `${sessionStorage.getItem("accentscountrySelected")}${inputValue}`;
    if (sessionStorage.getItem("accentscountrySelected") === "US") {
      topicID = `${sessionStorage.getItem("accentscountrySelected")}${sessionStorage.getItem("accentsstateSelected")}`;
      const localeUSData: any = await fetchData(topicID);
      setUSlocation(localeUSData);

      if (localeUSData) {
        handleChangeValueUStopic("", false, localeUSData.meta.titles[0].title, localeUSData);
      }
    }
  };

  const handleChangeValuetopic = (event: any, isEvent: boolean, selectionValue: string, localeData: any) => {
    const inputValue = isEvent ? event.target.value : selectionValue;
    const filterData: any = isEvent ? islocation : localeData;
    let articlesList = filterData.meta.titles.filter((data: any) => data.title === inputValue);
    sessionStorage.setItem("topicSelected", inputValue);
    setTopic(inputValue);
    let CNtopic = filterData.items.filter((data: any) => data.id === articlesList[0].id);
    setbody(CNtopic[0]);
  };

  const handleChangeValueUStopic = (event: any, isEvent: boolean, selectionValue: string, localeUSData: any) => {
    const inputValue = isEvent ? event.target.value : selectionValue;
    const filterData: any = isEvent ? isUSlocation : localeUSData;
    let articlesList = filterData.meta.titles.filter((data: any) => data.title === inputValue);
    sessionStorage.setItem("topicUSSelected", inputValue);
    setUSTopic(inputValue);
    let CNtopic = filterData.items.filter((data: any) => data.id === articlesList[0].id);
    setUSbody(CNtopic[0]);
  };

  const nextClick = () => {
    if (isbody.id < islocation.items.length) {
      let nextarticlesList = islocation.meta.titles.filter(
        (data: any) => data.id === islocation.items[isbody.id + 1].id
      );
      sessionStorage.setItem("topicSelected", nextarticlesList[0].title);
      setbody(islocation.items[isbody.id + 1]);
      setTopic(nextarticlesList[0].title);
    }
  };

  const nextUSClick = () => {
    if (isUSbody.id < isUSlocation.items.length) {
      let nextarticlesList = isUSlocation.meta.titles.filter(
        (data: any) => data.id === isUSlocation.items[isUSbody.id + 1].id
      );
      sessionStorage.setItem("topicUSSelected", nextarticlesList[0].title);
      setUSbody(isUSlocation.items[isUSbody.id + 1]);
      setUSTopic(nextarticlesList[0].title);
    }
  };

  const [, settoastOptions] = useReducer((state: any, newState: any) => ({ ...state, ...newState }), {
    toastOpen: false,
    toastSeverity: "error",
    toastMessageKey: "",
  });

  const handleToastOptionsDirect = (name: string, val: any) => {
    settoastOptions({ [name]: val });
  };

  const toasterHandle = (open: boolean, severity: string, messageKey: string) => {
    handleToastOptionsDirect("toastSeverity", severity);
    handleToastOptionsDirect("toastMessageKey", messageKey);
    handleToastOptionsDirect("toastOpen", !!open);
  };

  let accentsContinentSelected = sessionStorage.getItem("accentsContinentSelected");

  useEffect(() => {
    if (sessionStorage.getItem("accentsContinentSelected")) {
      let countryList = ADcountryLists.filter(
        (data) => data.Name === sessionStorage.getItem("accentsContinentSelected")
      );
      setCountries(countryList[0].countries);
      setStates(countryList[0].states);
    }
  }, [accentsContinentSelected,ADcountryLists]);

  useEffect(() => {
    handleChange("", false, AccentsAndDialectsDD[0].ContinentList[0]);
    sessionStorage.setItem("accentsContinentSelected", AccentsAndDialectsDD[0].ContinentList[0]);
  }, []);

  return (
    <div className="accentsAndDialects_Container">
      <div className="accentsAndDialects_child_header">
        <div className="AD_Title">
          <h3 className="accentsAndDialects_header_text">{translate("accentsAndDialects_heading")}</h3>
        </div>
      </div>

      <div className="ADbody-Location">
        <div className="ADchild-Location">
          <div
            className={
              sessionStorage.getItem("accentscountrySelected") === "US" ? "ADcountry-USLocation" : "ADcountry-Location"
            }
          >
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="demo-simple-select-outlined-label">{translate("SAR")}</InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label"
                id="Continent"
                value={sessionStorage.getItem("accentsContinentSelected") || ""}
                onChange={(event) => handleChange(event, true, "")}
                label={translate("SAR")}
              >
                {continents.map((option: any, index: number) => {
                  return <MenuItem key={index} value={option}>{translate(option)}</MenuItem>;
                })}
              </Select>
            </FormControl>
          </div>

          <div
            className={
              sessionStorage.getItem("accentscountrySelected") === "US" ? "ADcountry-USLocation" : "ADcountry-Location"
            }
          >
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="demo-simple-select-outlined-label-countries">{translate("SAL")}</InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label-countries"
                id="Countries"
                value={sessionStorage.getItem("accentscountrySelected") || ""}
                onChange={(event) => handleChangeValue(event, true, "")}
                label={translate("SAL")}
              >
                {countries.map((option: any, index: number) => {
                  return <MenuItem key={index} value={option}>{translate(option)}</MenuItem>;
                })}
              </Select>
            </FormControl>
          </div>

          {isstatedisabled && (
            <div
              className={
                sessionStorage.getItem("accentscountrySelected") === "US"
                  ? "ADcountry-USLocation"
                  : "ADcountry-Location"
              }
            >
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="demo-simple-select-outlined-label-states">
                  {translate("profile_statePlaceholder")}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label-states"
                  id="States"
                  value={sessionStorage.getItem("accentsstateSelected") || ""}
                  onChange={(event) => handleChangeValueStates(event, true, "")}
                  label={translate("profile_statePlaceholder")}
                >
                  {states.map((option: any, index: number) => {
                    return <MenuItem key={index} value={option}>{translate(option)}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </div>
          )}
          {isdisabled && (
            <div
              className={
                sessionStorage.getItem("accentscountrySelected") === "US"
                  ? "ADcountry-USLocation"
                  : "ADcountry-Location"
              }
            >
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="demo-simple-select-outlined-label-topics">{translate("SAT")}</InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label-topics"
                  id="Topics"
                  value={topic}
                  onChange={(event) => handleChangeValuetopic(event, true, "", "")}
                  label={translate("SAT")}
                >
                  {islocation
                    ? islocation.meta.titles.map((option: any) => {
                        return (
                          <MenuItem key={option.id} id={option.id} value={option.title}>
                            {option.title}
                          </MenuItem>
                        );
                      })
                    : ""}
                </Select>
              </FormControl>
            </div>
          )}

          {isUSdisabled && (
            <div
              className={
                sessionStorage.getItem("accentscountrySelected") === "US"
                  ? "ADcountry-USLocation"
                  : "ADcountry-Location"
              }
            >
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="demo-simple-select-outlined-label">{translate("SAT")}</InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="Topics"
                  value={topicUS}
                  onChange={(event) => handleChangeValueUStopic(event, true, "", "")}
                  label={translate("SAT")}
                >
                  {isUSlocation
                    ? isUSlocation.meta.titles.map((option: any) => {
                        return (
                          <MenuItem key={option.id} id={option.id} value={option.title}>
                            {option.title}
                          </MenuItem>
                        );
                      })
                    : ""}
                </Select>
              </FormControl>
            </div>
          )}
        </div>
      </div>

      {isdisabled && (
        <div className="accentsContent-bodyContainer">
          {islocation && (
            <React.Fragment>
              {isbody && (
                <React.Fragment>
                  <div className="accentsContent-Container">
                    <div className="ADblock-Parentheadertext">
                      <h2 className="ADblock-headertext">
                        {translate(sessionStorage.getItem("accentsContinentSelected") || "")}:{" "}
                        {translate(sessionStorage.getItem("accentscountrySelected") || "")}{" "}
                      </h2>
                    </div>

                    <div className="accentsPlayer">
                      <PersonOutlineIcon></PersonOutlineIcon>
                      <span className="audiotext-Header">{sessionStorage.getItem("topicSelected") || ""}</span>
                      <span className="ADaudioPlayer">
                        <ReactAudioPlayer
                          src={process.env.REACT_APP_CN_BLOBSTORAGE + isbody.Audio}
                          controls={true}
                          loop={false}
                          controlsList="nodownload"
                          className="AD-AudioPlayer"
                        />
                      </span>
                    </div>
                    <h2 className="ADbody-header">{translate(isbody.title)}</h2>
                    <div className="ADPara-align">
                      <span dangerouslySetInnerHTML={{ __html: isbody.body }} />
                    </div>
                  </div>
                  <div className={isbody.id === islocation.items.length - 1 ? "ADNextPagination" : "ADPagination"}>
                    <Button type="button" variant="contained" color="primary" onClick={nextClick}>
                      <Typography variant="subtitle2">{translate("button_next")}</Typography>
                    </Button>
                  </div>
                </React.Fragment>
              )}
            </React.Fragment>
          )}
        </div>
      )}
      {isUSdisabled && (
        <div className="accentsContent-bodyContainer">
          {isUSlocation && (
            <React.Fragment>
              {isUSbody && (
                <React.Fragment>
                  <div className="accentsContent-Container">
                    <div className="ADblock-Parentheadertext">
                      <h2 className="ADblock-headertext">
                        {translate(sessionStorage.getItem("accentsContinentSelected") || "")}:{" "}
                        {translate(sessionStorage.getItem("accentscountrySelected") || "")}-
                        {translate(sessionStorage.getItem("accentsstateSelected") || "")}{" "}
                      </h2>
                    </div>
                    <div className="accentsPlayer">
                      <PersonOutlineIcon></PersonOutlineIcon>
                      <span className="audiotext-Header">{sessionStorage.getItem("topicUSSelected") || ""}</span>
                      <span className="ADaudioPlayer">
                        <ReactAudioPlayer
                          src={process.env.REACT_APP_CN_BLOBSTORAGE + isUSbody.Audio}
                          controls={true}
                          loop={false}
                          controlsList="nodownload"
                          className="AD-AudioPlayer"
                        />
                      </span>
                    </div>
                    <h2 className="ADbody-header">{translate(isUSbody.title)}</h2>
                    <div className="ADPara-align">
                      <span dangerouslySetInnerHTML={{ __html: isUSbody.body }} />
                    </div>
                  </div>
                  <div className={isUSbody.id === isUSlocation.items.length - 1 ? "ADNextPagination" : "ADPagination"}>
                    <Button type="button" variant="contained" color="primary" onClick={nextUSClick}>
                      <Typography variant="subtitle2">{translate("button_next")}</Typography>
                    </Button>
                  </div>
                </React.Fragment>
              )}
            </React.Fragment>
          )}
        </div>
      )}
    </div>
  );
};

export default AccentsAndDialects;
